import styled, { css } from 'styled-components';
import { Divider as divider } from 'antd';

const Divider = styled(divider)`
  ${props =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
  ${props =>
    props.bg &&
    css`
      background-color: ${props.bg};
    `}
    ${props =>
    props.width &&
    css`
      width: ${props.width};
      min-width: ${props.width};
    `}
    ${props =>
    (props.pb || props.pb === 0) &&
    css`
      padding-bottom: ${props.pb}px;
    `}
`;

/** @component */
export default Divider;
